import { render, staticRenderFns } from "./CatalogoDialog.vue?vue&type=template&id=52b6579c&scoped=true"
import script from "./CatalogoDialog.vue?vue&type=script&lang=js"
export * from "./CatalogoDialog.vue?vue&type=script&lang=js"
import style0 from "./CatalogoDialog.vue?vue&type=style&index=0&id=52b6579c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b6579c",
  null
  
)

export default component.exports